import type { GenericObject } from './generic.interface'

export type URL = string
export type STRING_IN_JSON = string
export type TranslationObject = GenericObject
export type URLLanguageObject = GenericObject
